const puzzle = {
  id: "EFJ2DZMuJMsudY8xSejM",
  name: "Do You Speak English?",
  rebuses: [
    {
      id: "8abb28a8-163c-411e-ae44-e4cc5ab1eb6",
      clues: [
        {
          id: "0cdcabe3-7887-4b3a-a82b-f348babdf827",
          clueValues: [
            {
              id: "4a85fc08-0cdcb-4177-aa83-1",
              value: "HollywoodWeighingScale",
              type: "customComponent",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "Find out the weights of circle, square and triangle balls. Start by comparing them to grey balls.",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(50% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "4124htre0-c433-48c5-a8ba-2",
                value: "2663",
              },
            ],
            solvedText: "2663",
          },
        },
        {
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(41% - 10px)",
          },
          clueValues: [
            {
              value: "StarVennDiagram",
              id: "56d4frwec2-ba54-44ea-b04d-3",
              subtext: "",
              type: "customComponent",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "2-714f-4f126-b682-4",
          helperText: "",
          dependsOn: [],
          solutionInfo: {
            solvedText: "Star",
            type: "text",
            possibleSolutions: [
              {
                id: "7ec3mnba79b-4e54-4369-91d1-5",
                value: "Star",
              },
              {
                id: "7124c79b-4e54-4369-91d1-6",
                value: "Stars",
              },
            ],
          },
        },
        {
          id: "6hhhb125-e96d-4179-8e1d-7",
          clueValues: [
            {
              id: "3a606b2a-3c99-4bfe-a0cc-8",
              value: "uBfT3gXD.png",
              type: "image",
              subtext: "Hollywood",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "Who has the 2663rd star on the Hollywood Walk of Fame?",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(50% - 10px)",
          },
          dependsOn: [
            {
              id: "154yya19a-0ce1-474b-b4d9-9",
              value: "0cdcabe3-7887-4b3a-a82b-f348babdf827",
            },
            {
              id: "e637d8c9-9824-402f-aa27-11",
              value: "2-714f-4f126-b682-4",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "815ybdb7-01a5-446a-b599-13",
            value: "Anne Hathaway",
          },
        ],
        solvedText: "Anne Hathaway",
      },
    },

    {
      id: "3f51cvbae-ecc5-49cb-b54b-14",
      clues: [
        {
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(41% - 10px)",
          },
          clueValues: [
            {
              value: "MapVennDiagram",
              id: "2",
              subtext: "",
              type: "customComponent",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "19a4f-714f-4fe8-b682-15",
          helperText:
            "Butterfly type - Araschnia levana, Painting by Jasper Johns - Made in 1961.",
          dependsOn: [],
          solutionInfo: {
            solvedText: "Map",
            type: "text",
            possibleSolutions: [
              {
                id: "7ec3c79b-4e54-4369-91d1-16",
                value: "Map",
              },
            ],
          },
        },
        {
          id: "5224433b-8737-49b4-96dc-17",
          clueValues: [
            {
              id: "e5dbd155-002b-4d84-872a-18",
              value: "60°10'13.9\"N 24°56'28.7\"E",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
            {
              id: "694287f8-2b74-44dd-879c-19",
              value: "48°51'50.4\"N 2°20'13.7\"E",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
            {
              id: "14e767ad-f540-4294-b4df-20",
              value: "40°45'31.9\"N 73°58'37.1\"W",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "Look at the statues and fountains at these locations. What geometrical object do they have in common?",
          subtext: "Geometrical object",
          clueGroup: 0,
          style: {
            width: "calc(50% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "be96d4e3-4853-4d59-b213-21",
                value: "Sphere",
              },
              {
                id: "0dc9af08-724b-49ec-aa41-22",
                value: "Spheres",
              },
              {
                id: "bf427051-48fe-47f1-95ea-23",
                value: "Ball",
              },
              {
                id: "818a513c-9a11-4dc7-8cfd-24",
                value: "Balls",
              },
            ],
            solvedText: "Sphere",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "d115clkj-f12a-451b-ac84-25",
            value: "Globe",
          },
          {
            id: "b37d0f84-9d12-473b-81ba-26",
            value: "Globus",
          },
        ],
        solvedText: "Globe",
      },
    },
    {
      id: "29bfgf-c6fc-43bd-800e-27",
      clues: [
        {
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(41% - 10px)",
          },
          clueValues: [
            {
              value: "CesarVennDiagram",
              id: "1",
              subtext: "",
              type: "customComponent",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "1-714f-4fe8-b682-beb2cbeac4c6",
          helperText: "Origin of these words is the same (person).",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            type: "customComponent",
            possibleSolutions: [
              {
                id: "7ec3c79b-4e54-4369-91d1-28",
                value: "",
              },
            ],
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "56b46776-2683-4bf8-b2114-29",
            value: "Julius Caesar",
          },
          {
            id: "4cd0fdff-33a1-40f3-9483-30",
            value: "Caesar",
          },
          {
            id: "bdeb8c4c-3891-47fd-a402-31",
            value: "Cesar",
          },
          {
            id: "54981ae2-595e-4bf4-a2120-32",
            value: "Cezar",
          },
          {
            id: "54981ae2-8676-4bf4-a2120-32",
            value: "Julius Cesar",
          },
          {
            id: "54981ae2-8676-4bf4-a2120-32",
            value: "Julius Cezar",
          },
        ],
        solvedText: "Julius Caesar",
      },
    },
    {
      id: "c71e013c-25fb-4d71-b025-33",
      clues: [
        {
          id: "81ed8fa8-054b-4d4a-9e6b-34",
          clueValues: [
            {
              id: "fceda035-a4f5-4739-ae28-35",
              value: "Anne Hathaway",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "She was the wife of the person we're looking for.",
          subtext: "Not that one",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "a1155535-0a40-4b3c-a43f-abc5197fc4a9",
          clueValues: [
            {
              id: "cc953570-da69-4d1e-91c1-cd894c473013",
              value: "Globe",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "It's a building in London.",
          subtext: "Not the map thingy",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "181182-d355-41aa-9e05-ccef11346eac",
          clueValues: [
            {
              id: "a98460a9-f583-4771-92d2-b15ef7bbe2a2",
              value: "Julius Caesar",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "It's a play.",
          subtext: "Not the person",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "bf91632c5-4332-4aff-aee1-1cee4c9dgfh68",
            value: "William Shakespeare",
          },
          {
            id: "a7b1c8f8f-5daf-4b72-8891-02b5acb6bc1",
            value: "Shakespeare",
          },
        ],
        solvedText: "William Shakespeare",
      },
    },
  ],
};

export default puzzle;
